import React, { useEffect, useState } from "react";
import ContentImage from "../../BoxReview/components/ContentImage";
import { BoxImageURL, BoxLabelURL } from "../../../lib/boxReview/BoxReviewUtils";
import { Image } from "semantic-ui-react";
import { conveyorBoxEndpoints } from "../../../lib/conveyorbox/endpoints";

type Props = {
  boxBarcode: string;
  imageBytes: any;
  labelUrl: string;
};

const ShippingImages = ({ boxBarcode, imageBytes, labelUrl }: Props) => {
  // const [imageBytes, setImageBytes] = useState(null);
  // const [labelUrl, setLabelUrl] = useState(null);

  // useEffect(() => {
  //   if (imageBytes) return;
  //   conveyorBoxEndpoints.loadContentImage(boxBarcode).then((res) => {
  //     setImageBytes(res.imageBytes);
  //   });
  // }, []);

  return (
    <>
      <ContentImage imageBytes={imageBytes} imageUrl={""} />
      {labelUrl ? <Image src={BoxLabelURL(boxBarcode)} className="label-image" /> : ""}
    </>
  );
};

export default ShippingImages;
